import { intercept } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Col, Row, Table } from 'reactstrap';
import WellFooter from 'src/Components/Footer/WellFooter';
import { TestsStore } from 'src/Stores/Tests/TestsStore';
import { ITest } from '../../../../Interfaces/TestInterface';
import { IContact, IWarehouse, IWell } from '../../../../Interfaces/WellInterface';
import ButtonRow from '../../../ButtonRow';
import DataTable from '../../../DataTable';
import Footer from '../../../Footer';
import WorkflowHeader from '../../WorkflowHeader';
import WellCloseButton from '../WellCloseButton';
import WellRevertCloseButton from "../WellRevertCloseButton";




interface IParams {
    wellId: number | string;
}

interface IList {
    headers: any[];
    rows: any[];
}

@inject('stores')
@observer
class WellReview extends React.Component {
    public props: any;
    private engineerDataSet: IList;
    private operatorDataSet: IList;
    private contractorDataSet: IList;
    private contactDataSet: IList;
    public params: IParams;
    private TestsStore: TestsStore;
    private test: ITest = new ITest();
    private warehouses: IWarehouse[] = [];
    private WellsStore: any;
    private well: IWell = new IWell();

    // disposers
    public warehouseDisposer: any;
    public wellDisposer: any;
    public testDisposer: any;

    public state = {
        contactDataSet: this.contactDataSet,
        contractorDataSet: this.contractorDataSet,
        engineerDataSet: this.engineerDataSet,
        operatorDataSet: this.operatorDataSet,
        test: this.test,
        warehouses: this.warehouses,
        well: this.well,
        wellPageTitle: 'New Well'
    };

    constructor(props: any) {
        super(props);

        this.WellsStore = this.props.stores.WellsStore;
        this.TestsStore = this.props.stores.TestsStore;
        this.params = this.props.match.params;

        this.getWarehouseDetails = this.getWarehouseDetails.bind(this);

    }

    public componentDidMount() {
        this.WellsStore.getWarehouses();
        this.WellsStore.getWellDetails(this.params.wellId);
        this.createDisposers();
    }

    public componentWillUnmount() {
        this.warehouseDisposer();
        this.wellDisposer();
        this.testDisposer();
        this.warehouseDisposer();
    }

    public createDisposers() {
        this.testDisposer = intercept(this.TestsStore, 'test', (change: any) => {
            this.setState({
                test: change.newValue
            });
            return change;
        });
        this.wellDisposer = intercept(this.WellsStore, 'well', (change: any) => {
            this.setState({
                well: change.newValue,
                wellPageTitle: change.newValue.wellName
            });
            this.formatContactDataTable();
            this.formatContractorDataTable();
            this.formatEngineerDataTable();
            this.formatOperatorDataTable();
            return change;
        });
        this.warehouseDisposer = intercept(this.WellsStore, 'warehouses', (change: any) => {
            this.setState({
                warehouses: change.newValue
            });

            return change;
        });
    }

    private formatContactDataTable() {
        const newDataList: any[] = [];
        const tableHeaders = [
            'Name',
            'Type',
            'Mobile Phone',
            'Email'
        ];
        if ( this.state.well.otherContacts ) {
            this.state.well.otherContacts.map((contact: IContact, index: number) => {
                const newObject = [
                    {
                        content: contact.firstName + ' ' + contact.lastName
                    },
                    {
                        content: contact.otherTypeName
                    },
                    {
                        content: contact.phoneMobile
                    },
                    {
                        content: contact.email
                    }
                ];
                newDataList.push(newObject);
            });
        }
        const listStructure = {
            headers: tableHeaders,
            rows: newDataList
        };
        this.setState({
            contactDataSet: listStructure
        });
    }

    private formatContractorDataTable() {
        const newDataList: any[] = [];
        const tableHeaders = [
            'Name',
            'Mobile Phone',
            'Email'
        ];
        if ( this.state.well.contractorContacts ) {
            this.state.well.contractorContacts.map((contractor: IContact, index: number) => {
                const newObject = [
                    {
                        content: contractor.firstName + ' ' + contractor.lastName
                    },
                    {
                        content: contractor.phoneMobile
                    },
                    {
                        content: contractor.email
                    }
                ];
                newDataList.push(newObject);
            });
        }
        const listStructure = {
            headers: tableHeaders,
            rows: newDataList
        };
        this.setState({
            contractorDataSet: listStructure
        });
    }

    private formatEngineerDataTable() {
        const newDataList: any[] = [];
        const tableHeaders = [
            'Name',
            'Mobile Phone',
            'Email'
        ];
        if ( this.state.well.engineers ) {
            this.state.well.engineers.map((engineer: IContact, index: number) => {
                const newObject = [
                    {
                        content: engineer.firstName + ' ' + engineer.lastName
                    },
                    {
                        content: engineer.phoneMobile
                    },
                    {
                        content: engineer.email
                    }
                ];
                newDataList.push(newObject);
            });
        }
        const listStructure = {
            headers: tableHeaders,
            rows: newDataList
        };
        this.setState({
            engineerDataSet: listStructure
        });
    }

    private formatOperatorDataTable() {
        const newDataList: any[] = [];
        const tableHeaders = [
            'Name',
            'Mobile Phone',
            'Email'
        ];
        if ( this.state.well.operatorContacts ) {
            this.state.well.operatorContacts.map((operator: IContact, index: number) => {
                const newObject = [
                    {
                        content: operator.firstName + ' ' + operator.lastName
                    },
                    {
                        content: operator.phoneMobile
                    },
                    {
                        content: operator.email
                    }
                ];
                newDataList.push(newObject);
            });
        }
        const listStructure = {
            headers: tableHeaders,
            rows: newDataList
        };
        this.setState({
            operatorDataSet: listStructure
        });
    }

    private getWarehouseDetails(warehouseId: string | number, field: string) {
        const warehouses = this.state.warehouses;
        let value;
        warehouses.map((warehouse: any) => {
            if ( warehouse.id === warehouseId ) {
                value = warehouse[field];
            }
        });
        return value;
    }

    private buttonNavigation = (event: any) => {
        const $target = event.target;
        if ( $target.name === 'previous' ) {
            if (this.props.match.params.taskId) {
                this.props.history.push('/well/' + this.props.match.params.wellId + '/test/' + this.props.match.params.taskId + '/welldata/solidscontrol');
            } else {
                if (this.props.workflowHeaderItems[0].some((w: string) => w === 'Dispatches')) {
                    this.props.history.push('/well/' + this.props.match.params.wellId + '/dispatches');
                } else {
                    this.props.history.push('/well/' + this.props.match.params.wellId + '/contacts');
                }
            }
        } else if ( $target.name === 'next') {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/wellclose/productsreview');
        } else if ( $target.name === 'startNewTest') {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/test/new/welldata/testsetup');
        } else if ( $target.name === 'returnToWellList' ) {
            this.props.history.push('/home');
        } else {
            this.props.history.push('/home');
        }
    }

    public render() {
        return(
            <div className="WellReview">
                <WorkflowHeader wellSetupComplete={this.state.well.wellSetupComplete} workflowHeaderItems={this.props.workflowHeaderItems}/>
                <Row>
                    <Col md="12">
                        <h4 className="table-h4">Details</h4>
                    </Col>
                    <Col md="12">
                        <Table className="freeTable">
                            <tbody>
                                <tr>
                                    <td colSpan={2}>Well Name</td>
                                    <td colSpan={2}>Well Type</td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>{this.state.well.wellName}</td>
                                    <td colSpan={2}>{this.state.well.wellType}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>Operator</td>
                                    <td>API Number</td>
                                    <td>Sidetrack Number</td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>{this.state.well.operator.operatorName}</td>
                                    <td>{this.state.well.apiNumber}</td>
                                    <td>{this.state.well.sidetrack}</td>
                                </tr>
                                <tr>
                                    <td>Contractor</td>
                                    <td>Rig Number</td>
                                    <td>State</td>
                                    <td>County/Parish</td>
                                </tr>
                                <tr>
                                    <td>{this.state.well.contractor.contractorName}</td>
                                    <td>{this.state.well.rigNumber}</td>
                                    <td>{this.state.well.state}</td>
                                    <td>{this.state.well.countyParish}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>Nova Group Email</td>
                                    <td>Start Date</td>
                                    <td>Spud Date</td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>{this.state.well.groupEmail}</td>
                                    <td>{this.state.well.startDate}</td>
                                    <td>{this.state.well.spudDate}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>
                </Row>
                <Row>
                    <Col md="12">
                        <h4 className="table-h4">Location - GPS Coordinates (NAD 27)</h4>
                    </Col>
                </Row>
                { this.state.well.wellType !== 'Vertical' ?
                    <Row>
                        <Col md="12">
                            <Table className="freeTable">
                                <tbody>
                                    <tr>
                                        <td>Field/Area/Unit</td>
                                        <td>SHL Latitude</td>
                                        <td>SHL Longitude</td>
                                        <td>BHL Latitude</td>
                                        <td>BHL Longitude</td>
                                    </tr>
                                    <tr>
                                        <td>{this.state.well.fieldAreaUnit}</td>
                                        <td>{this.state.well.shlgpsLatitude}</td>
                                        <td>{this.state.well.shlgpsLongitude}</td>
                                        <td>{this.state.well.bhlgpsLatitude}</td>
                                        <td>{this.state.well.bhlgpsLatitude}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row> :
                    <Row>
                        <Col md="12">
                            <Table className="freeTable">
                                <tbody>
                                    <tr>
                                        <td>Field/Area/Unit</td>
                                        <td>SHL Latitude</td>
                                        <td>SHL Longitude</td>
                                    </tr>
                                    <tr>
                                        <td>{this.state.well.fieldAreaUnit}</td>
                                        <td>{this.state.well.shlgpsLatitude}</td>
                                        <td>{this.state.well.shlgpsLongitude}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                }
                <Row>
                    <Col md="12">
                        <h4 className="table-h4">Location - SHL Well Legal</h4>
                    </Col>
                </Row>
                { this.state.well.state !== 'TX' ?
                    <Row>
                        <Col md="12">
                            <Table className="freeTable nomargin">
                                <tbody>
                                    <tr>
                                        <td>Section</td>
                                        <td>Township</td>
                                        <td>Range</td>
                                    </tr>
                                    <tr>
                                        <td>{this.state.well.shlSection}</td>
                                        <td>{this.state.well.shlTownship + this.state.well.shlTownshipDirection}</td>
                                        <td>{this.state.well.shlRange + this.state.well.shlRangeDirection}</td>
                                    </tr>
                                </tbody>
                            </Table>
                            <Table className="freeTable">
                                <tbody>
                                    <tr>
                                        <td>From Point NS</td>
                                        <td>From Point NS Distance</td>
                                        <td>From Point EW</td>
                                        <td>From Point EW Distance</td>
                                    </tr>
                                    <tr>
                                        <td>{this.state.well.shlFromPointNS}</td>
                                        <td>{this.state.well.shlFromPointNSDistance}</td>
                                        <td>{this.state.well.shlFromPointEW}</td>
                                        <td>{this.state.well.shlFromPointEWDistance}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                : this.state.well.state === 'TX' && this.state.well.shlisLabour ?
                    <Row>
                        <Col md="12">
                            <Table className="freeTable nomargin">
                                <tbody>
                                    <tr>
                                        <td>Labour</td>
                                        <td>League</td>
                                        <td>Survey</td>
                                    </tr>
                                    <tr>
                                        <td>{this.state.well.shlLabour}</td>
                                        <td>{this.state.well.shlLeague}</td>
                                        <td>{this.state.well.shlSurvey}</td>
                                    </tr>
                                </tbody>
                            </Table>
                            <Table className="freeTable">
                                <tbody>
                                    <tr>
                                        <td>From Point NS</td>
                                        <td>From Point NS Distance</td>
                                        <td>From Point EW</td>
                                        <td>From Point EW Distance</td>
                                    </tr>
                                    <tr>
                                        <td>{this.state.well.shlFromPointNS}</td>
                                        <td>{this.state.well.shlFromPointNSDistance}</td>
                                        <td>{this.state.well.shlFromPointEW}</td>
                                        <td>{this.state.well.shlFromPointEWDistance}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                :
                    <Row>
                        <Col md="12">
                            <Table className="freeTable nomargin">
                                <tbody>
                                    <tr>
                                        <td>Section</td>
                                        <td>Block</td>
                                        <td>Township</td>
                                        <td>Abstract</td>
                                        <td>Survey</td>
                                    </tr>
                                    <tr>
                                        <td>{this.state.well.shlSection}</td>
                                        <td>{this.state.well.shlBlock + this.state.well.shlBlockDirection}</td>
                                        <td>{this.state.well.shlTownship + this.state.well.shlTownshipDirection}</td>
                                        <td>{this.state.well.shlAbstract}</td>
                                        <td>{this.state.well.shlSurvey}</td>
                                    </tr>
                                </tbody>
                            </Table>
                            <Table className="freeTable">
                                <tbody>
                                    <tr>
                                        <td>From Point NS</td>
                                        <td>From Point NS Distance</td>
                                        <td>From Point EW</td>
                                        <td>From Point EW Distance</td>
                                    </tr>
                                    <tr>
                                        <td>{this.state.well.shlFromPointNS}</td>
                                        <td>{this.state.well.shlFromPointNSDistance}</td>
                                        <td>{this.state.well.shlFromPointEW}</td>
                                        <td>{this.state.well.shlFromPointEWDistance}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                }
                { this.state.well.wellType !== 'Vertical' ?
                    <Row>
                        <Col md="12">
                            <h4 className="table-h4">Location - BHL Well Legal</h4>
                        </Col>
                    </Row> : null
                }
                { this.state.well.wellType !== 'Vertical' && this.state.well.state !== 'TX' ?
                    <Row>
                        <Col md="12">
                            <Table className="freeTable nomargin">
                                <tbody>
                                    <tr>
                                        <td>Section</td>
                                        <td>Township</td>
                                        <td>Range</td>
                                    </tr>
                                    <tr>
                                        <td>{this.state.well.bhlSection}</td>
                                        <td>{this.state.well.bhlTownship + this.state.well.bhlTownshipDirection}</td>
                                        <td>{this.state.well.bhlRange + this.state.well.bhlRangeDirection}</td>
                                    </tr>
                                </tbody>
                            </Table>
                            <Table className="freeTable">
                                <tbody>
                                    <tr>
                                        <td>From Point NS</td>
                                        <td>From Point NS Distance</td>
                                        <td>From Point EW</td>
                                        <td>From Point EW Distance</td>
                                    </tr>
                                    <tr>
                                        <td>{this.state.well.bhlFromPointNS}</td>
                                        <td>{this.state.well.bhlFromPointNSDistance}</td>
                                        <td>{this.state.well.bhlFromPointEW}</td>
                                        <td>{this.state.well.bhlFromPointEWDistance}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                : this.state.well.wellType !== 'Vertical' && this.state.well.state === 'TX' && this.state.well.bhlisLabour ?
                    <Row>
                        <Col md="12">
                            <Table className="freeTable nomargin">
                                <tbody>
                                    <tr>
                                        <td>Labour</td>
                                        <td>League</td>
                                        <td>Survey</td>
                                    </tr>
                                    <tr>
                                        <td>{this.state.well.bhlLabour}</td>
                                        <td>{this.state.well.bhlLeague}</td>
                                        <td>{this.state.well.bhlSurvey}</td>
                                    </tr>
                                </tbody>
                            </Table>
                            <Table className="freeTable">
                                <tbody>
                                    <tr>
                                        <td>From Point NS</td>
                                        <td>From Point NS Distance</td>
                                        <td>From Point EW</td>
                                        <td>From Point EW Distance</td>
                                    </tr>
                                    <tr>
                                        <td>{this.state.well.bhlFromPointNS}</td>
                                        <td>{this.state.well.bhlFromPointNSDistance}</td>
                                        <td>{this.state.well.bhlFromPointEW}</td>
                                        <td>{this.state.well.bhlFromPointEWDistance}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                : this.state.well.wellType !== 'Vertical' && this.state.well.state === 'TX' && !this.state.well.bhlisLabour ?
                    <Row>
                        <Col md="12">
                            <Table className="freeTable nomargin">
                                <tbody>
                                    <tr>
                                        <td>Section</td>
                                        <td>Block</td>
                                        <td>Township</td>
                                        <td>Abstract</td>
                                        <td>Survey</td>
                                    </tr>
                                    <tr>
                                        <td>{this.state.well.bhlSection}</td>
                                        <td>{this.state.well.bhlBlock + this.state.well.bhlBlockDirection}</td>
                                        <td>{this.state.well.bhlTownship + this.state.well.bhlTownshipDirection}</td>
                                        <td>{this.state.well.bhlAbstract}</td>
                                        <td>{this.state.well.bhlSurvey}</td>
                                    </tr>
                                </tbody>
                            </Table>
                            <Table className="freeTable">
                                <tbody>
                                    <tr>
                                        <td>From Point NS</td>
                                        <td>From Point NS Distance</td>
                                        <td>From Point EW</td>
                                        <td>From Point EW Distance</td>
                                    </tr>
                                    <tr>
                                        <td>{this.state.well.bhlFromPointNS}</td>
                                        <td>{this.state.well.bhlFromPointNSDistance}</td>
                                        <td>{this.state.well.bhlFromPointEW}</td>
                                        <td>{this.state.well.bhlFromPointEWDistance}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row> : null
                }
                <Row>
                    <Col md="12">
                        <h4 className="table-h4">Engineers</h4>
                    </Col>
                    <Col md="12">
                        <DataTable
                            list={this.state.engineerDataSet}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md="12">
                        <Row>
                            <Col md="4">
                                <h4 className="table-h4">Operator Rep</h4>
                            </Col>
                            <Col md="4">
                                <h4 className="table-h4">{this.state.well.operator.operatorName}</h4>
                            </Col>
                            <Col md="4">
                                <h4 className="table-h4">{this.state.well.operator.groupEmail}</h4>
                            </Col>
                        </Row>
                    </Col>
                    <Col md="12">
                        <DataTable
                            list={this.state.operatorDataSet}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md="12">
                        <Row>
                            <Col md="4">
                                <h4 className="table-h4">Contractor Rep</h4>
                            </Col>
                            <Col md="4">
                                <h4 className="table-h4">{this.state.well.contractor.contractorName}</h4>
                            </Col>
                            <Col md="4">
                                <h4 className="table-h4">{this.state.well.contractor.groupEmail}</h4>
                            </Col>
                        </Row>
                    </Col>
                    <Col md="12">
                        <DataTable
                            list={this.state.contractorDataSet}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md="12">
                        <h4 className="table-h4">Other Contacts</h4>
                    </Col>
                    <Col md="12">
                        <DataTable
                            list={this.state.contactDataSet}
                        />
                    </Col>
                </Row>
                { this.props.location.pathname.includes('test') ?
                    <Footer well={this.WellsStore.well} test={this.TestsStore.test} onNavigate={this.buttonNavigation} saveDisabled={true} />
                    : this.state.well.wellSetupComplete && this.state.well.wellStatus === 'Active' ?
                    <ButtonRow>
                        <WellRevertCloseButton />
                        { <WellCloseButton />}
                        { this.TestsStore.canCreateNewTest() && <Button color="primary" name="startNewTest" onClick={this.buttonNavigation}>Start New Test</Button> }
                        <Button className="secondary" name={this.state.well.wellStatus !== "Active" ? "next" : "returnToWellList"} onClick={this.buttonNavigation}>{this.state.well.wellStatus !== "Active" ? "Next" : "Return To Well List"}</Button>
                        <WellFooter />
                    </ButtonRow>
                    :
                    <ButtonRow>
                        <WellRevertCloseButton />
                        { <WellCloseButton />}
                        <Button className="secondary" name="previous" onClick={this.buttonNavigation}>Previous</Button>
                        <Button className="secondary" name={this.state.well.wellStatus !== "Active" ? "next" : "returnToWellList"} onClick={this.buttonNavigation}>{this.state.well.wellStatus !== "Active" ? "Next" : "Return To Well List"}</Button>
                        <WellFooter />
                    </ButtonRow>
                }
            </div>
        );
    }
}

export default withRouter(WellReview);



// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/WellReview/WellReview.tsx